<div class="modal-header">
  <h4 class="modal-title pull-left">Attachment View</h4>
  <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <div class="text-center">
        <img [src]="attachmentImage | secure | async" class="mw-100"/>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <!--  <a download [href]="downloadUrl | secure | async" class="btn btn-dark">Download</a>-->
  <button (click)="download()" class="btn btn-dark">Download</button>
</div>
